module.exports = __webpack_public_path__ + "static/minu-445cb30bcddee9427d306ff40629f715.jpg";